<template>
    <div v-if="label" class="main-container">
        <h2 class="subtitle">{{label.titles.title}}
            <Info multilined bottom tooltipText="Visualisez vos consommations mensuelles"/>
        </h2>
        <PodSelection v-bind:userId="user._id" @selectedPod="onPodSelected"/>
        <!-- <div v-if="pod">
            {{label.titles.registers}} :
            <div v-for="variable of pod.variable" v-bind:key="variable.id">
                <input @change="onSelectedRegistersChange" v-model="selectedRegisters" :value="variable.id" type="checkbox" :id="variable.id">
                <label :for="variable.id"> {{variable.name}}</label>
            </div>
        </div> -->
        <div v-if="podTimeframes && podTimeframes.length > 0">
            <label class="label">{{label.forms.timeframe}} 
                <Info multilined bottom :tooltipText="label.forms.timeframeTooltip"/>
            </label>
        </div>
        <div style="display: flex; gap: 2rem; align-items: flex-start; flex-wrap: wrap; margin-bottom: 2rem;">
            <div>
                <div v-for="tf in regularTimeframes" :key="tf">
                    <input @change="onSelectedTfChange" :value="tf" v-model="selectedTimeframes" :id="tf" type="checkbox">
                    <label :for="tf">{{getTimeframeFriendlyName(tf)}}</label>
                </div>
            </div>
            
            <div v-if="impactTimeframes && impactTimeframes.length > 0">
                <div v-for="tf in impactTimeframes" :key="tf">
                    <input @change="onSelectedTfChange" :value="tf" v-model="selectedTimeframes" :id="tf" type="checkbox">
                    <label :for="tf">{{getTimeframeFriendlyName(tf)}}</label>
                </div>
            </div>
        </div>
        <div>
            <!-- Consumptions -->
            <!-- Table -->
            <div class="table-container">
              <table class="table is-hoverable">
                <thead>
                  <tr>
                      <th>{{label.forms.register}}</th>
                      <th>{{label.forms.from}}</th>
                      <th>{{label.forms.to}}</th>
                      <th>{{label.forms.consumption}}</th>
                      <th>{{label.forms.unit}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="periodicalConsumptions && periodicalConsumptions.length > 0 && !loadingConsumptions">
                    <tr v-for="consumption in periodicalConsumptions" v-bind:key="consumption.id">
                        <td>{{getRegisterFriendlyName(consumption.variable.name)}}</td>
                        <td>{{prettyFormatDate(consumption.dateFrom)}}</td>
                        <td>{{prettyFormatDate(consumption.date)}}</td>
                        <td>{{formatConsumptionValue(consumption.value)}}</td>
                        <td>{{pod.energy.inputUnit}}</td>
                    </tr>
                  </template>
                  <template v-else>
                    Pas de consommations mensuelles à visualiser
                  </template>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="field is-grouped">
              <div class="control">
                <button
                  :disabled="consumptionsPageIndex <= 0 || loadingConsumptions"
                  class="button is-small"
                  @click="consumptionsPageIndex--">{{label.buttons.before}}</button>
              </div>
              <div class="control"><span class="is-size-7"><strong>{{label.buttons.page}} {{consumptionsPageIndex+1}}</strong></span></div>
              <div class="control">
                <button
                  :disabled="onLastConsumptionsPage || loadingConsumptions"
                  class="button is-small"
                  @click="consumptionsPageIndex++">{{label.buttons.after}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PodSelection from '../components/PodSelection.vue';
import { MeteringService } from '../services';
import moment from 'moment';
import Info from '../components/Info.vue'
import { TIMEFRAME_FRIENDLY_MAPPING, getRegisterFriendlyName, formatNumberWithThousandsSeparator } from '../helpers'


export default {
    components: {
        PodSelection,
        Info
    },
    data() {
        return {
            indexes: [],
            variables: [],
            clipodStartDate: null,
            pod: null,
            periodicalConsumptions: [],
            indexesPageIndex: 0,
            consumptionsPageIndex: 0,
            // number of elements per page
            number: 10,
            onLastConsumptionsPage: true,
            loadingIndexes: false,
            loadingConsumptions: false,
            meteringBeingEdited: null,

            // selectedRegisters: [],
            selectedTimeframes: [],

            threeYearsAgo: moment().subtract(3, "years"),
            oldErrors: {
                value: false
            },
            // metering creation/modification form
            // meteringForm: {
            //     dateFrom: moment().format("YYYY-MM-DD"),
            //     date: moment().format("YYYY-MM-DD"),
            //     registersValues: {}
            // },
            showModalIndex: false
        }
    },
    computed: {
        ...mapState("account", ["user"]),
        ...mapState({ label: state => state.labels.consumptions }),
        today() {
            return moment().format("YYYY-MM-DD");
        },
        tomorrow() {
            let date = new Date();
            date.setDate(date.getDate() + 1);
            return date;
        },
        minMeteringDate() {
            let minDate;
            if(this.indexes.length > 0)
                minDate = moment(this.indexes[0].date).add(1,"days");
            else
                minDate = moment(this.clipodStartDate);
            if(minDate < this.threeYearsAgo) {
                return this.threeYearsAgo.format("YYYY-MM-DD");
            }
            return minDate.format("YYYY-MM-DD");
        },
        podTimeframes() {
            if(!this.pod)
                return []
            let timeframes = []
            for(let variable of this.pod.variable) {
                // Exclude PWR and PWR_EX variables from listing
                if(variable.timeframe && variable.timeframe !== 'PWR' && variable.timeframe !== 'PWR_EX' && !timeframes.includes(variable.timeframe))
                    timeframes.push(variable.timeframe)
            }
            return timeframes
        },
        impactTimeframes() {
          return this.podTimeframes.filter(tf => ["EC", "MD", "PK"].includes(tf))
        },
        regularTimeframes() {
          return this.podTimeframes.filter(tf => !["EC", "MD", "PK"].includes(tf))
        },
        registersToLoad() {
            if(!this.pod || !this.podTimeframes)
                return []
            return this.pod.variable.filter(v => v.meter && this.selectedTimeframes.includes(v.timeframe)).map(v => v.id)
        },
    },
    methods: {
        ...mapActions("labels", ["getLabel"]),
        getRegisterFriendlyName(registerName) {
            return getRegisterFriendlyName(registerName)
        },
        getTimeframeFriendlyName(timeframe) {
          return TIMEFRAME_FRIENDLY_MAPPING[timeframe]
        },
        prettyFormatDate(date) {
          return moment(date).format('DD-MM-YYYY')
        },
        formatConsumptionValue(value) {
          return formatNumberWithThousandsSeparator(Number(parseFloat(value).toFixed(3)))
        },
        onPodSelected(clipod) {
            // Defensive: if no clipod (no access points), clear state and return
            if (!clipod) {
                this.indexesPageIndex = 0;
                this.consumptionsPageIndex = 0;
                this.clipodStartDate = null;
                this.pod = null;
                this.selectedTimeframes = [];
                this.periodicalConsumptions = [];
                return;
            }

            // this.resetCreationFormValues(clipod.pod);
            this.indexesPageIndex = 0;
            this.consumptionsPageIndex = 0;
            this.clipodStartDate = clipod.validFrom;
            this.pod = clipod.pod
            this.selectedTimeframes = this.podTimeframes
            // check that there is at least one register for the pod
            if(this.registersToLoad.length > 0) {
                this.loadConsumptions()
            }
        },
        // onSelectedRegistersChange() {
        //     this.loadConsumptions();
        // },
        onSelectedTfChange() {
            this.loadConsumptions()
        },
        // resetCreationFormValues(pod) {
        //     this.meteringForm.registersValues = {};
        //     for(let i in pod.variable) {
        //         this.meteringForm.registersValues[pod.variable[i].id] = "0.0";
        //     }
        // },
        loadConsumptions() {
            this.periodicalConsumptions = []

            if(this.registersToLoad.length == 0) {
                return
            }

            this.loadingConsumptions = true
            //load periodical consumptions
            MeteringService.getMeteringsWPaging(this.selectedTimeframes, this.pod.id, this.user._id, this.consumptionsPageIndex, 10, false).then(
                consumptionsInfos => {
                    this.loadingConsumptions = false
                    if(consumptionsInfos) {
                      this.onLastConsumptionsPage = consumptionsInfos.lastPage;
                      // sort variables in good order
                      if(this.pod.energy.energyName == 'elec') {
                          consumptionsInfos.meterings.sort((a,b) => {
                            const indexOfA = this.label.forms.mappingRegister.indexOf(a.variable.name.toLowerCase());
                            const indexOfB = this.label.forms.mappingRegister.indexOf(b.variable.name.toLowerCase());
                            if(moment(a.dateFrom).format("YYYY-MM-DD") == moment(b.dateFrom).format("YYYY-MM-DD")) {
                                if(indexOfA >= 0 ) {
                                    if(indexOfB >= 0) {
                                        return indexOfA - indexOfB;
                                    } else {
                                        return -1;
                                    }
                                } else {
                                    if(indexOfB >= 0) {
                                        return 1;
                                    } else {
                                        return a.name < b.name ? -1 : 1;
                                    }
                                }
                            }
                            return a.dateFrom > b.dateFrom ? -1 : 1;
                        });
                      }

                      this.periodicalConsumptions = consumptionsInfos.meterings;
                    }
                    else {
                      this.onLastConsumptionsPage = true;
                      this.periodicalConsumptions = [];
                    }
                }
            )
        },
    },
    created() {
      this.getLabel({ view: 'consumptions' })
    },
    watch: {
        consumptionsPageIndex() {
            this.loadConsumptions();
        }
    }
}
</script>

<style scoped>
.table-container {
  margin-top: 30px;
}
</style>